<!-- upload-panel.component.html -->
<app-floating-panel
  *ngIf="isPanelVisible"
  [title]="
    (isPanelMinimized ? 'Uploading: ' + (totalProgress$ | async) + '%' : 'File Uploads') +
    ' (' +
    (activeUploadsCount$ | async) +
    ' active)'
  "
  width="400px"
  height="250px"
  initialPosition="bottom-right"
  [margin]="20"
  (closed)="onPanelClosed()"
  (minimizedChange)="onPanelMinimized($event)"
>
  <div class="upload-panel-content">
    <div class="upload-header">
      <div class="total-progress">
        <div class="progress-label">Total Progress: {{ totalProgress$ | async }}%</div>
        <div class="progress-bar-container">
          <div class="progress-bar" [style.width.%]="totalProgress$ | async"></div>
        </div>
      </div>

      <button class="clear-button" *ngIf="(completedUploadsCount$ | async) ?? 0 > 0" (click)="clearCompleted()">
        Clear Completed
      </button>
    </div>

    <div class="upload-list">
      <ng-container *ngIf="(uploads$ | async)?.length === 0">
        <div class="no-uploads">No active uploads</div>
      </ng-container>

      <div
        class="upload-item upload-row resume-prompt"
        *ngFor="let request of reconfirmationRequests$ | async; trackBy: trackByRequestId"
      >
        <div class="icon-area">
          <img src="assets/icons/zip-file-bold.svg" alt="file-icon" />
        </div>
        <div class="info-area">
          <div class="file-info">
            <div class="file-name clipped-text" [title]="request.fileName">
              {{ request.fileName }}
            </div>
            <div class="status-text warning">
              <span>Interrupted</span>
            </div>
          </div>
        </div>
        <button class="resume-button" (click)="promptForFile(request)">Resume</button>
        <button class="cancel-button" (click)="discardUpload(request)" aria-label="Discard upload">
          <span aria-hidden="true">✕</span>
        </button>
      </div>

      <div class="upload-item upload-row" *ngFor="let upload of uploads$ | async; trackBy: trackByUploadId">
        <div class="icon-area">
          <img src="assets/icons/zip-file-bold.svg" alt="upload-cloud-icon" />
        </div>
        <div class="info-area">
          <div class="file-info">
            <div class="file-name clipped-text" [title]="upload.file.name">{{ upload.file.name }}</div>
            <div
              class="status-text"
              [ngClass]="upload.status === 'error' && upload.useDirectGcs ? 'warning' : getStatusClass(upload.status)"
            >
              <span *ngIf="upload.status === 'uploading'">{{ upload.progress }}%</span>
              <span *ngIf="upload.status === 'completed'">Completed</span>
              <!-- Direct-to-GCS failures stay resumable (session kept), so present them like the
                   reload-driven "Interrupted" state rather than a dead-end "Failed". -->
              <span *ngIf="upload.status === 'error' && upload.useDirectGcs">Interrupted</span>
              <span *ngIf="upload.status === 'error' && !upload.useDirectGcs">Failed</span>
              <span *ngIf="upload.status === 'cancelled'">Cancelled</span>
              <span *ngIf="upload.status === 'queued'">Waiting...</span>
            </div>
            <div class="file-size">{{ formatFileSize(upload.file.size) }}</div>
          </div>

          <div class="upload-status"></div>

          <div class="progress-bar-container">
            <div class="progress-bar" [ngClass]="getStatusClass(upload.status)" [style.width.%]="upload.progress"></div>
          </div>
        </div>
        <button
          *ngIf="upload.status === 'error' && upload.useDirectGcs"
          class="resume-button"
          (click)="resumeFailedUpload(upload.id)"
        >
          Resume
        </button>
        <button
          *ngIf="upload.status === 'uploading' || upload.status === 'queued' || upload.status === 'error'"
          class="cancel-button"
          (click)="closeUpload(upload.id, upload.file.name)"
          aria-label="Cancel upload"
        >
          <span aria-hidden="true">✕</span>
        </button>
      </div>
    </div>
  </div>
</app-floating-panel>

<!-- hidden file input field -->
<input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />
